import { render } from "./Smartlink.vue?vue&type=template&id=664e7272&scoped=true"
import script from "./Smartlink.vue?vue&type=script&lang=js"
export * from "./Smartlink.vue?vue&type=script&lang=js"

import "./Smartlink.vue?vue&type=style&index=0&id=664e7272&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-664e7272"]])

export default __exports__